<div class="flex flex-row items-center mb-14">
  <mat-checkbox
    class="pl-12 pr-16"
    [checked]="tag.checked"
    (change)="checkChange(tag)"
    [disabled]="
      loadingService.watch({
        action: loadingAction.CHANGE_CUSTOMER_BILLER_TAG,
        namespace: 'tag',
        id: getId()
      }) | async
    "
  ></mat-checkbox>
  {{ tag.name }}
  <app-icon name="edit" size="18" class="edit-icon" (click)="edit.emit()" *ngIf="tag.id"></app-icon>
</div>
